var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStops(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5333 6C11.36 6 10.4 5.1 10.4 4C10.4 2.9 11.36 2 12.5333 2C13.7067 2 14.6667 2.9 14.6667 4C14.6667 5.1 13.7067 6 12.5333 6ZM17.8667 2H20V2.4C19.8933 4.6 19.1467 6.3 17.5467 7.5C17.0133 7.9 16.3733 8.2 15.7333 8.4V22H13.6V16H11.4667V22H9.33333V10.1C9.01333 10.2 8.8 10.3 8.69333 10.4C7.73333 11.1 7.21067 12 7.2 13.5V14H5.06667V13.5C5.06667 11.5 5.824 9.91 7.31733 8.71C8.49067 7.81 10.4 7 12.5333 7C14.6667 7 15.392 6.54 16.2453 5.94C17.312 5.14 17.8667 4 17.8667 2.5V2ZM4 16H7.2V22H4V16Z",
    fill: "#20A8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStops);
export default __webpack_public_path__ + "static/media/stops.ad9f22662cd37a65db267bdb094e0ad5.svg";
export { ForwardRef as ReactComponent };